<template>
  <div
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <event-tree-grid />
  </div>
</template>

<script>
import eventTreeGrid from './components/crm/eventTreeGrid'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'EventManager',
  components: { eventTreeGrid },
  data() { return {} },
  created() {},
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  },
  methods: {}
}
</script>

<style lang="scss">
</style>
